import script from "./JsonBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonBlock.vue?vue&type=script&setup=true&lang=js"

import "./JsonBlock.vue?vue&type=style&index=0&id=42f53391&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f53391"]])

export default __exports__